




import { Component, Vue } from 'vue-property-decorator';
import { BackgroundDrawer } from '@/components/layout/background-particles/particle-drawer';

@Component
export default class BackgroundParticles extends Vue {

    mounted() {
        const drawer = new BackgroundDrawer('particles-background');
        drawer.draw();
    }

}
